import axios from 'axios';
import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.policy_templates.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', templates: resp.data.data });
      });
  },
  update: (dispatch, templateId, values, successCallback, errorCallback) => {
    axios
      .put(
        routes.api.policy_templates.update(templateId),
        values,
      )
      .then((resp) => {
        successCallback();
        dispatch({ type: 'UPDATE', template: resp.data.data });
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },
  move: (dispatch, list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    dispatch({
      type: 'MOVE',
      templates: result,
    });

    axios
      .post(routes.api.policy_templates.sort, {
        templates: result.map((item, index) => ({ id: item.id, index })),
      })
      .then((_resp) => {});
  },
};
